import React, { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { LockKey, FloppyDisk } from "@phosphor-icons/react";

export default function AdminChangePassword() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!current || !next) { toast.error("Please fill all fields"); return; }
    if (next.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    if (next !== confirm) { toast.error("New passwords do not match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed. Please log in again.");
      setTimeout(() => { logout(); navigate("/admin/login", { replace: true }); }, 1200);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-change-password">
      <div className="mb-6">
        <h1 className="font-heading font-black text-2xl text-slate-900">Change Password</h1>
        <p className="text-slate-500 text-sm mt-1">Update your admin password any time.</p>
      </div>

      <form onSubmit={submit} className="bg-white rounded-2xl shadow-sm border border-slate-200 p-5 sm:p-6 space-y-4 max-w-md" data-testid="change-password-form">
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1.5">Current Password</label>
          <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="cp-current" className="w-full h-14 px-4 rounded-xl border border-slate-200 text-lg focus:outline-none focus:ring-2 focus:ring-brand/40" placeholder="••••••••" autoComplete="current-password" />
        </div>
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1.5">New Password</label>
          <input type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="cp-new" className="w-full h-14 px-4 rounded-xl border border-slate-200 text-lg focus:outline-none focus:ring-2 focus:ring-brand/40" placeholder="At least 6 characters" autoComplete="new-password" />
        </div>
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1.5">Confirm New Password</label>
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" className="w-full h-14 px-4 rounded-xl border border-slate-200 text-lg focus:outline-none focus:ring-2 focus:ring-brand/40" placeholder="Re-type new password" autoComplete="new-password" />
        </div>
        <button type="submit" disabled={saving} data-testid="cp-submit" className="w-full h-14 rounded-xl bg-brand text-white font-bold text-lg flex items-center justify-center gap-2 hover:bg-brand-hover transition-colors disabled:opacity-60">
          {saving ? <LockKey className="w-5 h-5 animate-pulse" /> : <FloppyDisk className="w-5 h-5" weight="bold" />}
          {saving ? "Saving…" : "Update Password"}
        </button>
      </form>
    </div>
  );
}
